// @flow
import client from '../../client'

// types
export type FlightData = {
  search_id: string,
  airline_code: string,
  flight_number: string,
  flight_direction: string,
  airport_code: string,
  flight_datetime?: ?string,
  pickup_datetime?: ?string,
  return_voyage?: boolean,
}

export type FlightVerifyResult = {
  is_valid: boolean,
  message_title?: string,
  message: string,
  extra_data: {},
}

// Endpoints
export const VERIFY_FLIGHT_ENDPOINT = '/flights/verify/'

/**
 * Verify if flight information is valid or not
 * @param {Object} data Flight information
 * @param {string} data.airline_code Flight airline code
 * @param {string} data.flight_number Flight number
 * @param {string} data.flight_direction Flight direction (departing|arriving)
 * @param {string} data.airport_code Flight airport code
 * @param {string} [data.flight_datetime] Flight date time
 * @param {string} [data.pickup_datetime] Pickup date time. You must provide one of the optional datetimes.
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const verifyFlight = (data: FlightData): Promise<FlightVerifyResult> =>
  client.post(VERIFY_FLIGHT_ENDPOINT, { body: data })

export default verifyFlight
